import { BaseModalManager } from './shared/BaseModalManager.js';

export default function showSelectedFurniture() {
  const isPresent = document.querySelector('.js-furniture-modal');
  if (!isPresent) {
    return;
  }

  return new BaseModalManager({
    type: 'furniture',
    triggerSelector: '.js-furniture-modal',
    ajaxAction: 'get_selected_furniture',
    dataKey: 'selected_furniture',
    emptyMessage: 'Mööblit ei ole veel valitud'
  });
}